import { theme } from 'styles/configure-theme';

interface IHeroTheme {
  brand: string;
  color?: string;
  hasBackground: boolean;
  reversedFromSanity: boolean;
}

export const configTheme = {
  plk: {
    default: {
      background: theme.token('background-hero-default'),
      reversed: true,
    },
    purple: {
      background: theme.token('background-hero-purple'),
      reversed: true,
    },
    orange: {
      background: theme.token('background-hero-orange'),
      reversed: true,
    },
  },
  bk: {
    default: {
      background: theme.token('background-hero-default'),
      reversed: true,
    },
    brown: {
      background: theme.token('background-hero-bqq-brown'),
      reversed: true,
    },
    red: {
      background: theme.token('background-hero-fiery-red'),
      reversed: true,
    },
    green: {
      background: theme.token('background-hero-crunchy-green'),
      reversed: true,
    },
    orange: {
      background: theme.token('background-hero-flaming-orange'),
      reversed: false,
    },
    yellow: {
      background: theme.token('background-hero-melty-yellow'),
      reversed: false,
    },
  },
  fhs: {
    default: {
      background: theme.token('background-hero-default'),
      reversed: true,
    },
    red: {
      background: theme.token('background-hero-house-red'),
      reversed: true,
    },
    yellow: {
      background: theme.token('background-hero-house-yellow'),
      reversed: false,
    },
  },
};

export const getHeroTheme = ({ brand, color, hasBackground, reversedFromSanity }: IHeroTheme) => {
  if (hasBackground && color) {
    return configTheme[brand][color];
  }

  if ((!hasBackground && reversedFromSanity) || (hasBackground && !color)) {
    return configTheme[brand].default;
  }

  return {};
};
